<template>
  <div class="l-container">
    <!-- <div>{{obj}}</div> -->

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('user_id')" v-bind:class="{ 'active': user_id }">User</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">office_id</btn>
        <btn class="m-btn--column" @click.native="switchV('channel_id')" v-bind:class="{ 'active': channel_id }">channel_id</btn>
        <btn class="m-btn--column" @click.native="switchV('state')" v-bind:class="{ 'active': state }">State</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>
    <div style="display: flex">
      <multiselect @select="select" v-model="watchOffice_channel.office_id" :options="filteredOffices" label="name" placeholder="" :show-labels="false"></multiselect>
      <multiselect @select="select" v-model="watchOffice_channel.channel_id" :options="channels" label="name" placeholder="" :show-labels="false"></multiselect>
      <button @click="postOffice_channel" style="width: 150px"><i class="fa fa-fw fa-plus"></i></button>
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <!-- <tr&#45;c slot="tr&#45;th"> -->
        <!--   <td&#45;c></td&#45;c> -->
        <!--   <td&#45;c style="text&#45;align: center">検索</td&#45;c> -->
        <!--   <template v&#45;if="id"><td&#45;c><input v&#45;model="search.id" type="text" @keyup="searchTable()"></td&#45;c></template> -->
        <!--   <template v&#45;if="user_id"><td&#45;c><input v&#45;model="search.user_id" type="text" @keyup="searchTable()"></td&#45;c></template> -->
        <!--   <template v&#45;if="office_id"> -->
        <!--     <td&#45;c class="select"> -->
        <!--       <multiselect @select="searchTable()" v&#45;model="watchSearch.office_id" :options="offices" label="name" placeholder="" :show&#45;labels="false"></multiselect> -->
        <!--     </td&#45;c> -->
        <!--   </template> -->
        <!--   <template v&#45;if="channel_id"> -->
        <!--     <td&#45;c class="select"> -->
        <!--       <multiselect @select="searchTable()" v&#45;model="watchSearch.channel_id" :options="channels" label="name" placeholder="" :show&#45;labels="false"></multiselect> -->
        <!--     </td&#45;c> -->
        <!--   </template> -->
        <!--   <template v&#45;if="state"><td&#45;c><input v&#45;model="search.state" type="text" @keyup="searchTable()"></td&#45;c></template> -->
        <!--   <template v&#45;if="created_at"><td&#45;c><input v&#45;model="search.created_at" type="text" @keyup="searchTable()"></td&#45;c></template> -->
        <!-- </tr&#45;c> -->

        <!-- <tr&#45;c slot="tr&#45;th"> -->
        <!--   <td&#45;c></td&#45;c> -->
        <!--   <td&#45;c style="text&#45;align: center">除外</td&#45;c> -->
        <!--   <template v&#45;if="id"><td&#45;c><input v&#45;model="search.not_id" type="text" @keyup="searchTable()"></td&#45;c></template> -->
        <!--   <template v&#45;if="user_id"><td&#45;c><input v&#45;model="search.not_user_id" type="text" @keyup="searchTable()"></td&#45;c></template> -->
        <!--   <template v&#45;if="office_id"> -->
        <!--     <td&#45;c class="select"> -->
        <!--       <multiselect @select="searchTable()" v&#45;model="watchSearch.not_office_id" :options="offices" label="name" placeholder="" :show&#45;labels="false"></multiselect> -->
        <!--     </td&#45;c> -->
        <!--   </template> -->
        <!--   <template v&#45;if="channel_id"> -->
        <!--     <td&#45;c class="select"> -->
        <!--       <multiselect @select="searchTable()" v&#45;model="watchSearch.not_channel_id" :options="channels" label="name" placeholder="" :show&#45;labels="false"></multiselect> -->
        <!--     </td&#45;c> -->
        <!--   </template> -->
        <!--   <template v&#45;if="state"><td&#45;c><input v&#45;model="search.not_state" type="text" @keyup="searchTable()"></td&#45;c></template> -->
        <!--   <template v&#45;if="created_at"><td&#45;c><input v&#45;model="search.not_created_at" type="text" @keyup="searchTable()"></td&#45;c></template> -->
        <!-- </tr&#45;c> -->

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="user_id"><th-c @click.native='sort("user_id")'>User</th-c></template>
          <template v-if="office_id"><th-c @click.native='sort("office_id")'>office_id</th-c></template>
          <template v-if="channel_id"><th-c @click.native='sort("channel_id")'>channel_id</th-c></template>
          <template v-if="state"><th-c @click.native='sort("state")'>State</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in filteredOffice_channels" :key="list.id">
          <template v-if="list.id == edit_id.edit_id">
            <td-c @click.native="cancelOffice_channel(list)" class="del" style="position: relative">戻る</td-c>
            <td-c @click.native="patchOffice_channel(list)" class="del" style="position: relative">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="user_id"><td-c>{{list.user_id}}</td-c></template>
            <template v-if="office_id"><td-c>{{list.mapOffice_id}}</td-c></template>
            <template v-if="channel_id"><td-c>{{list.mapChannel_id}}</td-c></template>
            <template v-if="state"><td-c style="border: solid 3px #41B883"><input type="text" v-model="list.state" style="font-weight: bold"></td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteOffice_channel(list)" class="del" style="position: relative">削除</td-c>
            <td-c @click.native="editOffice_channel(list)" class="del" style="position: relative">編集</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="user_id"><td-c>{{list.user_id}}</td-c></template>
            <template v-if="office_id"><td-c>{{list.mapOffice_id}}</td-c></template>
            <template v-if="channel_id"><td-c>{{list.mapChannel_id}}</td-c></template>
            <template v-if="state"><td-c>{{list.state}}</td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/office_channels/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'office_channel',
  pageNames: 'office_channels'
}

let _ = window._
export default {
  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      asc: '',
      desc: '',
      sortState: '',

      id: false,
      user_id: false,
      office_id: true,
      channel_id: true,
      state: true,
      created_at: false,

      search: {
        id: '',
        user_id: '',
        office_id: '',
        channel_id: '',
        state: '',
        created_at: '',

        not_id: '',
        not_user_id: '',
        not_office_id: '',
        not_channel_id: '',
        not_state: '',
        not_created_at: ''
      },

      watchSearch: {
        office_id: '',
        channel_id: '',

        not_office_id: '',
        not_channel_id: ''
      },

      office_channel: {
        office_id: '',
        channel_id: '',
        state: 1
      },

      watchOffice_channel: {
        office_id: '',
        channel_id: ''
      }
    }
  },
  watch: {
    'watchSearch.office_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watchSearch.not_office_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watchSearch.channel_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.channel_id = now.id
      } else {
        this.search.channel_id = ''
      }
    },

    'watchSearch.not_channel_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.not_channel_id = now.id
      } else {
        this.search.not_channel_id = ''
      }
    },

    'watchOffice_channel.office_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.office_channel.office_id = now.id
      } else {
        this.office_channel.office_id = ''
      }
    },

    'watchOffice_channel.channel_id': function (now, old) {
      // console.log(now)
      if (now) {
        this.office_channel.channel_id = now.id
      } else {
        this.office_channel.channel_id = ''
      }
    }
  },

  computed: {
    obj () {
      return obj
    },

    user () {
      return this.$store.getters.user
    },

    offices () {
      return this.$store.getters.offices.reverse()
    },

    filteredOffices () {
      if (this.user.office_id === 0) {
        return this.offices.filter(office => {
          return office
        })
      } else {
        return this.offices.filter(office => {
          return office.id === this.user.office_id
        })
      }
    },

    channels () {
      return this.$store.getters.channels
    },

    office_channels () {
      return this.$store.getters.office_channels
    },

    orderedOffice_channels () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.office_channels, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.office_channels, this.desc).reverse()
      }
    },

    mapOffice_channels () {
      return this.orderedOffice_channels.map(office_channel => {
        office_channel.mapOffice_id = this.calcArry(office_channel.office_id, 'offices')
        office_channel.mapChannel_id = this.calcArry(office_channel.channel_id, 'channels')
        return office_channel
      })
    },

    filteredOffice_channels () {
      if (this.user.office_id === 0) {
        return this.mapOffice_channels.filter(office_channel => {
          return office_channel
        })
      } else {
        return this.mapOffice_channels.filter(office_channel => {
          return office_channel.office_id === this.user.office_id
        })
      }
    }
  },
  methods: {
    calcArry (val, text) {
      // console.log(this[text])
      if (this[text].length > 0) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    select (selectedOption, id) {
      console.log(selectedOption)
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.user_id = false
      this.office_id = false
      this.channel_id = false
      this.state = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.user_id = true
      this.office_id = true
      this.channel_id = true
      this.state = true
      this.created_at = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    editOffice_channel (list) {
      this.edit_id.edit_id = list.id
    },

    postOffice_channel () {
      this.$store.dispatch('postOffice_channel', {
        office_channel: this.office_channel,
        reset_date: this.reset_date
      })
    },

    deleteOffice_channel (list) {
      this.$store.dispatch('deleteOffice_channel', list)
    },

    cancelOffice_channel (list) {
      this.$store.dispatch('cancelOffice_channel', {
        list: list,
        edit_id: this.edit_id
      })
    },

    patchOffice_channel (list) {
      this.$store.dispatch('patchOffice_channel', {
        list: list,
        edit_id: this.edit_id
      })
    },

    reset_date () {
      this.watchOffice_channel.office_id = 0
      this.watchOffice_channel.channel_id = 0
      this.office_channel.state = ''
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
  font-size: 12px;
}
.index-box {
  height: calc(100vh - 190px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  width: 80px;
  &:hover {
    background: black;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// Office_channelsIndex.vue?5f380ac7